import React, {
  FC, useMemo, useState,
} from 'react';
import _ from 'lodash';
import {
  Badge,
  DropdownItem,
} from 'reactstrap';
import ActionDots from 'app/components/general/ActionDots';

import { IOrganisationFee } from 'app/ducks/competitions/types';

import history from 'app/routes/history';
import Table from 'app/components/general/TableNew';
import StatusBadge from 'app/components/general/StatusBadge';
import Button from 'app/components/general/Button';
import PlusIcon from 'app/images/icons/plus.svg';

import * as competitionSelectors from 'app/ducks/competitions/selectors';
import IconModal from 'app/components/general/IconModal';
import DuplicateCompetition from './DuplicateCompetition';
// import ConnectIcon from 'app/images/icons/linked.svg';

interface IProps {
  actions: any;
  competitionsById: any[];
  competitionIds: string[];
  teamId?: string;
  headerTitle?: string;
  appReady?: boolean;
  isLoading?: boolean;
  manual?: boolean;
  saveFilters?: boolean;
  initialFilterConfig?: any;
  persistentFilterConfig?: any;
  pagination?: any;
}

const CompetitionsTable: FC<IProps> = (props: IProps = {
  manual: true,
  actions: undefined,
  competitionsById: undefined,
  competitionIds: undefined,
  initialFilterConfig: {},
  persistentFilterConfig: {},
  isLoading: false,
  pagination: undefined,
  selectTeam: undefined,
}) => {
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [selectedCompetitionId, setSelectedCompetitionId] = useState('');
  const fetchDataFromApi = ({
    sort, filter, pageNumber, pageSize,
  }): void => {
    if (
      props.appReady
      && !props.isLoading
      && (pageNumber !== props.pagination.page.number
        || (!_.isEmpty(sort) && sort !== props.pagination.sort)
        || filter !== props.pagination.filter)
    ) {
      props.actions.getAllCompetitions({
        page: {
          size: pageSize,
          number: pageNumber,
        },
        sort,
        filter,
      });
    }
  };

  const renderActionDots = (cellProps: {
    value: {
      competitionId: string;
    };
  }): React.ReactNode => (
    <ActionDots id={cellProps?.value?.competitionId}>
      <DropdownItem
        onClick={(): void => {
          setSelectedCompetitionId(cellProps?.value?.competitionId);
          setDuplicateModalOpen(true);
          // props.selectTeam(pc.teamId);

          // history.push(
          //   `/payment/match/${pc.matchPaymentId}/review`,
          // );
        }}
      >
        Duplicate
      </DropdownItem>
    </ActionDots>
  );


  const handleClick = (id: string): void => {
    props.actions.selectCompetition(id);
    history.push(`/competitions/${id}`);
  };

  const data = useMemo(() => {
    if (_.isEmpty(props.competitionsById) || props.competitionIds === undefined) {
      return [];
    }
    const competitionRows = _.reduce(
      props.competitionIds,
      (acc, id) => {
        if (!_.isEmpty(props.competitionsById[id])) {
          acc.push(
            competitionSelectors.getCompetitionSummary(
              props.competitionsById[id],
            ),
          );
        }
        return acc;
      },
      [],
    );

    return competitionRows;
  }, [props.competitionsById, props.competitionIds]);

  const columns = useMemo(() => [
    {
      Header: 'Name',
      accessor: 'name',
      className: 'col col-4',
      headerClassName: 'col col-4',
    },
    {
      Header: 'Public Status',
      sortable: false,
      disableSortBy: true,
      className: 'col col-3',
      headerClassName: 'col col-3',
      accessor: 'status',
      Cell: ((cellProps) => (
        <StatusBadge
          key="owing"
          paymentText={cellProps.value}
        />
      )),
    },
    {
      Header: 'Archived',
      sortable: false,
      disableSortBy: true,
      className: 'col col-3',
      headerClassName: 'col col-3',
      accessor: 'archived',
      Cell: (cellProps) => (
        <span className="text-grey text-weight-medium-bold">
          {cellProps.value ? 'Archived' : ''}
        </span>
      ),
    },
    {
      id: 'actionCol',
      Header: 'Actions',
      className: 'col col-2',
      headerClassName: 'col col-2',
      accessor: (row) => ({
        competitionId: row.id,
      }),
      Cell: renderActionDots,
    },

  ], []);

  const counterText = props.pagination.meta.totalCount === 1 ? '1 competition' : `${props.pagination.meta.totalCount || 0} competitions`;
  // const [error, response] = yield(yield TeammoApi(
  //   yield select(),
  // )).competitions.duplicate(action.payload);
  return (
    <div>
      <IconModal
        title="Duplicate Competition"
        icon={PlusIcon}
        handleCancel={() => setDuplicateModalOpen(false)}
        isOpen={duplicateModalOpen}
      >
        <DuplicateCompetition currentCompetition={props.competitionsById[selectedCompetitionId]} afterSubmit={() => setDuplicateModalOpen(false)} />
      </IconModal>
      <Table
        data={data}
        columns={columns}
        isLoading={props.isLoading}
        // aggressiveLoader
        headerTitle={props.headerTitle}
        objectTitle="competition"
        filterTitle="Competitions Data"
        counterText={counterText}
        handleClick={handleClick}
        filterable={false}
        saveFilters={props.saveFilters}
        manual={props.manual}
        getRowProps={(row) => {
          if (row.values.archived) {
            return {
              style: {
                opacity: 0.6,
              },
            };
          }
        }}
        fetchDataFromApi={fetchDataFromApi}
        // filterOptions={filterOptions}
        filterConfig={props.initialFilterConfig}
        persistentFilterConfig={props.persistentFilterConfig}
        pagination={props.pagination}
        showPagination
      >
        <Button
          onClick={() => history.push('/create-competition')}
          btnIcon={PlusIcon}
          className="btn-thinner btn-2"
        >
          Create Competition
        </Button>
      </Table>
    </div>
  );
};

export default CompetitionsTable;
